import { createContext } from 'react';

import { PortalBannerMessageFragment } from '@willow/graphql-iso/src/portal';
import { BorrowerId, PortalUserId, TOSVersion } from '@willow/types-iso';

export type PortalUser = {
  id: PortalUserId;
  borrowerId: BorrowerId;
  email: string;
  phoneNumbers: {
    home?: string;
    work?: string;
    cell?: string;
  };
  firstName: string;
  lastName: string;
  suffix: string | undefined;
  acceptedTerms: boolean;
  requiredTosVersion: TOSVersion;
  bannerMessages: PortalBannerMessageFragment[];
};

export type EmptyPortalUser = {
  id: undefined;
  borrowerId: undefined;
  email: undefined;
  phoneNumbers: {
    home: undefined;
    work: undefined;
    cell: undefined;
  };
  firstName: undefined;
  lastName: undefined;
  suffix: undefined;
  acceptedTerms: boolean;
  isAdmin: boolean;
  requiredTosVersion: TOSVersion;
  bannerMessages: PortalBannerMessageFragment[];
};

const EMPTY_PORTAL_USER: EmptyPortalUser = {
  id: undefined,
  borrowerId: undefined,
  email: undefined,
  phoneNumbers: {
    home: undefined,
    work: undefined,
    cell: undefined,
  },
  firstName: undefined,
  lastName: undefined,
  suffix: undefined,
  acceptedTerms: false,
  isAdmin: false,
  requiredTosVersion: 1,
  bannerMessages: [],
};

export const UserContext = createContext<PortalUser | EmptyPortalUser>(EMPTY_PORTAL_USER);
